import { TENANT_TYPE } from '@components/Ackodrive/common/constants'
import { getConfig } from '@configs/evnConfig'

export const getSegmentKey = env => getConfig(env)?.segmentKey?.[TENANT_TYPE.ACKOENTERPRISE]
